import React, { useRef } from 'react';
import { observer } from "mobx-react-lite";
import stores from 'cd-eft/models/Stores';
import { SingleCrossSection } from "./SingleCrossSection";
import { ThreeCrossSection } from './ThreeCrossSection';
import { CrossSectionManagerVM } from "./CrossSectionManagerVM";
import Icon from '@mdi/react';
import { graphTimeSeries24 } from "@esri/calcite-ui-icons";
import { CustomInput } from 'reactstrap';
import { EngineeringMapService } from 'cd-eft/framework/mapServices/EngineeringMapServices';
import './crosssection.scss';

const AppStore = stores.AppStore;

function CrossSectionManagerComponent(updateSnapIcon) {
  const vmRef = useRef<CrossSectionManagerVM>();
  if (!vmRef.current) {
    vmRef.current = new CrossSectionManagerVM(updateSnapIcon);
  }
  const vm = vmRef.current;

    return (
      <>
        {!!AppStore.designStore.designElementTypeId && AppStore.userProfileStore.applicationFlags.enablesinglecrosssection && (
          <div className="cross-section-container">
            {/* Toolbar button */}

              <button className="esri-widget--button cross-section-tool-btn" title="Cross Section" aria-label="cross section toolbar"
                onClick={() => vm.openCrossSectionToolbar()}
              >
                <Icon path={graphTimeSeries24} title="Cross Section Tool" size={0.8} className="esri-collapse__icon esri-icon-public" />
              </button>

            {!AppStore.designStore.hideCrossSectionToolbar && AppStore.userProfileStore.applicationFlags.enablecrosssectionviewer && (
              <div className="cross-section-toolbar">

                <div>
                  <p className={!AppStore.designStore.hideSingleCrossSection ? 'cs-text-active' : undefined}>Single Cross Section</p>
                  <CustomInput
                    type="switch"
                    id="SingleCrossSection"
                    data-testid="SingleCrossSection"
                    name="SingleCrossSection"
                    checked={!AppStore.designStore.hideSingleCrossSection}
                    onChange={() => vm.singleCrossSectionSwitchHandler(EngineeringMapService.instance.mapView)}
                  />
                </div>
                <hr />
                <div>
                  <p className={!AppStore.designStore.hideThreeCrossSection ? 'cs-text-active' : undefined}>Three Cross Section</p>
                  <CustomInput
                    type="switch"
                    id="ThreeCrossSection"
                    data-testid="ThreeCrossSection"
                    name="ThreeCrossSection"
                    checked={!AppStore.designStore.hideThreeCrossSection}
                    onChange={vm.threeCrossSectionSwitchHandler}
                  />
                </div>
                <hr />
                <div>
                  <p className={!AppStore.designStore.toggle3DMap ? 'cs-text-active' : undefined}>3D Map</p>
                  <CustomInput
                    type="switch"
                    id="open3DMap"
                    data-testid="open3DMap"
                    name="3DMap"
                    checked={!AppStore.designStore.toggle3DMap}
                    onChange={vm.switch3DMapHandler}
                  />
                </div>
              </div>
            )}


            {!AppStore.designStore.hideSingleCrossSection && !AppStore.designStore.hideCrossSectionToolbar ? (
              <div id="single-crosssection-container" >
                <SingleCrossSection />
              </div>
            ) : null}

            {!AppStore.designStore.hideThreeCrossSection && !AppStore.designStore.hideCrossSectionToolbar ? (
              <ThreeCrossSection />
            ) : null}
          </div>
        )}


      </>
    )
}

export const CrossSectionManager = observer(CrossSectionManagerComponent);